import React, { useState, useEffect, useRef } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation } from "react-router-dom";

import AppTopbar from "./AppTopbar";
import AppFooter from "./AppFooter";
import AppConfig from "./AppConfig";
import AppRightMenu from "./AppRightMenu";
import AppBreadcrumb from "./AppBreadcrumb";
import AppMenu from "./AppMenu";

import UsersCrud from "./pages/Users";
import PlansCrud from "./pages/Plans";
import ReasonCrud from "./pages/Reasons";
import RegionsCrud from "./pages/Region";
import DriversCrud from "./pages/Drivers";
import FranchisesCrud from "./pages/Franchises";
import CouponsCrud from "./pages/Coupons";
import FranchiseRegionsCrud from "./pages/FranchiseRegion";
import ServicesCrud from "./pages/Services";
import CategorysCrud from "./pages/Categorys";
import ParameterCrud from "./pages/Parameters";
import VehicheBrandCrud from "./pages/VehicheBrands";
import VehicheModelCrud from "./pages/VehicheModels";
import ReportClientsCrud from "./pages/Clients";
import ReportRacesCrud from "./pages/Reports/Races";
import ReportMetricsCrud from "./pages/Reports/Metrics";
import MessagesCrud from "./pages/Messages";
import OrdersCrud from "./pages/CallCenter/Orders";
import MonitorCrud from "./pages/CallCenter/Monitoring";
import MonitoringCrud from "./pages/Monitoring";

import Dashboard from "./components/Dashboard";
import FormLayoutDemo from "./components/FormLayoutDemo";
import InputDemo from "./components/InputDemo";
import FloatLabelDemo from "./components/FloatLabelDemo";
import InvalidStateDemo from "./components/InvalidStateDemo";
import ButtonDemo from "./components/ButtonDemo";
import TableDemo from "./components/TableDemo";
import ListDemo from "./components/ListDemo";
import TreeDemo from "./components/TreeDemo";
import PanelDemo from "./components/PanelDemo";
import OverlayDemo from "./components/OverlayDemo";
import MediaDemo from "./components/MediaDemo";
import MenuDemo from "./components/MenuDemo";
import MessagesDemo from "./components/MessagesDemo";
import FileDemo from "./components/FileDemo";
import ChartDemo from "./components/ChartDemo";
import MiscDemo from "./components/MiscDemo";
import Documentation from "./components/Documentation";
import IconsDemo from "./utilities/IconsDemo";
import CrudDemo from "./pages/CrudDemo";
import CalendarDemo from "./pages/CalendarDemo";
import TimelineDemo from "./pages/TimelineDemo";
import Invoice from "./pages/Invoice";
import Help from "./pages/Help";
import EmptyPage from "./pages/EmptyPage";
import BlocksDemo from "./components/BlocksDemo";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.scss";
import { useUser } from "./context/users";

const App = (props: any) => {
  const user = useUser();
  const franchise = user?.getUser()?.franchise;
  const acting_region_id = user?.getUser()?.actingRegion?.id;
  const is_callcenter = user?.getUser()?.is_callcenter;
  
  const [rightMenuActive, setRightMenuActive] = useState(false);
  const [configActive, setConfigActive] = useState(false);
  const [overlayMenuActive, setOverlayMenuActive] = useState(false);
  const [ripple, setRipple] = useState(true);

  const [menuMode, setMenuMode] = useState("sidebar");
  const [sidebarStatic, setSidebarStatic] = useState(true);
  const [pinActive, setPinActive] = useState(true);

  const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
  const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
  const [menuActive, setMenuActive] = useState(true);
  const [searchActive, setSearchActive] = useState(false);
  const [topbarMenuActive, setTopbarMenuActive] = useState(true);
  const [sidebarActive, setSidebarActive] = useState(true);

  const [activeInlineProfile, setActiveInlineProfile] = useState(false);
  const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);

  const copyTooltipRef = useRef<any>();
  const location = useLocation();

  PrimeReact.ripple = true;

  const gestaoList = () => {
    const list: any[] = [];

    list.push({ label: "Planos/Pacotes", icon: "pi pi-bitcoin", to: "/planos" });
    list.push({ label: "Parâmetros", icon: "pi pi-exclamation-triangle", to: "/parametros" });
    list.push({ label: "Usuarios", icon: "pi pi-user", to: "/usuarios" });

    return list;
  };

  const cadastroList = () => {
    const list: any[] = [];

    // Admin
    if(!franchise?.id) {
      list.push({ label: "Franquias", icon: "pi pi-globe", to: "/franquias" });
      list.push({ label: "Franquia - Região de atuação", icon: "pi pi-link", to: "/franquias-regioes"});
    }

    list.push({ label: "Serviços", icon: "pi pi-sort-alpha-down", to: "/servicos" });
    if (franchise?.id && !acting_region_id)
      list.push({ label: "Categorias", icon: "pi pi-tags", to: "/categorias" });
    list.push({ label: "Cupons", icon: "pi pi-money-bill", to: "/cupons" });

    // Admin
    if(!franchise?.id) {
      list.push({ label: "Região de atuação", icon: "pi pi-map-marker", to: "/regioes" });
      list.push({ label: "Modelo de Veículos", icon: "pi pi-bolt", to: "/modelos-de-veiculos" });
      list.push({ label: "Marcas de Veículos", icon: "pi pi-car", to: "/marcas-de-veiculos" });
      list.push({ label: "Motivos & Assuntos", icon: "pi pi-align-left", to: "/motivos" });
    }

    return list;
  };

  const devMenu = [
    {
      label: "UI Kit",
      icon: "pi pi-star",
      items: [
        { label: "Form Layout", icon: "pi pi-id-card", to: "/formlayout" },
        { label: "Input", icon: "pi pi-check-square", to: "/input" },
        { label: "Float Label", icon: "pi pi-bookmark", to: "/floatlabel" },
        {
          label: "Invalid State",
          icon: "pi pi-exclamation-circle",
          to: "/invalidstate",
        },
        {
          label: "Button",
          icon: "pi pi-mobile",
          to: "/button",
          className: "rotated-icon",
        },
        { label: "Table", icon: "pi pi-table", to: "/table" },
        { label: "List", icon: "pi pi-list", to: "/list" },
        { label: "Tree", icon: "pi pi-share-alt", to: "/tree" },
        { label: "Panel", icon: "pi pi-tablet", to: "/panel" },
        { label: "Overlay", icon: "pi pi-clone", to: "/overlay" },
        { label: "Media", icon: "pi pi-image", to: "/media" },
        { label: "Menu", icon: "pi pi-bars", to: "/menu" },
        { label: "Message", icon: "pi pi-comment", to: "/message" },
        { label: "File", icon: "pi pi-file", to: "/file" },
        { label: "Chart", icon: "pi pi-chart-bar", to: "/chart" },
        { label: "Misc", icon: "pi pi-circle", to: "/misc" },
      ],
    },
    {
      label: "PrimeBlocks",
      icon: "pi pi-prime",
      items: [
        {
          label: "Free Blocks",
          icon: "pi pi-eye",
          to: "/blocks",
          badge: "NEW",
        },
        {
          label: "All Blocks",
          icon: "pi pi-globe",
          url: "https://www.primefaces.org/primeblocks-react",
          target: "_blank",
        },
      ],
    },
    // Icons
    {
      label: "Utilities",
      icon: "pi pi-compass",
      items: [
        { label: "Icons", icon: "pi pi-prime", to: "/icons" },
        {
          label: "PrimeFlex",
          icon: "pi pi-desktop",
          url: "https://www.primefaces.org/primeflex",
          target: "_blank",
        },
      ],
    },
    {
      label: "Pages",
      icon: "pi pi-briefcase",
      items: [
        { label: "Crud", icon: "pi pi-pencil", to: "/crud" },
        { label: "Calendar", icon: "pi pi-calendar-plus", to: "/calendar" },
        { label: "Timeline", icon: "pi pi-calendar", to: "/timeline" },
        {
          label: "Landing",
          icon: "pi pi-globe",
          url: "assets/pages/landing.html",
          target: "_blank",
        },
        { label: "Login", icon: "pi pi-sign-in", to: "/login" },
        { label: "Invoice", icon: "pi pi-dollar", to: "/invoice" },
        { label: "Help", icon: "pi pi-question-circle", to: "/help" },
        { label: "Error", icon: "pi pi-times-circle", to: "/error" },
        {
          label: "Not Found",
          icon: "pi pi-exclamation-circle",
          to: "/notfound",
        },
        { label: "Access Denied", icon: "pi pi-lock", to: "/access" },
        { label: "Empty Page", icon: "pi pi-circle", to: "/empty" },
      ],
    },
    {
      label: "Hierarchy",
      icon: "pi pi-align-left",
      items: [
        {
          label: "Submenu 1",
          icon: "pi pi-align-left",
          items: [
            {
              label: "Submenu 1.1",
              icon: "pi pi-align-left",
              items: [
                { label: "Submenu 1.1.1", icon: "pi pi-align-left" },
                { label: "Submenu 1.1.2", icon: "pi pi-align-left" },
                { label: "Submenu 1.1.3", icon: "pi pi-align-left" },
              ],
            },
            {
              label: "Submenu 1.2",
              icon: "pi pi-align-left",
              items: [
                { label: "Submenu 1.2.1", icon: "pi pi-align-left" },
                { label: "Submenu 1.2.2", icon: "pi pi-align-left" },
              ],
            },
          ],
        },
        {
          label: "Submenu 2",
          icon: "pi pi-align-left",
          items: [
            {
              label: "Submenu 2.1",
              icon: "pi pi-align-left",
              items: [
                { label: "Submenu 2.1.1", icon: "pi pi-align-left" },
                { label: "Submenu 2.1.2", icon: "pi pi-align-left" },
                { label: "Submenu 2.1.3", icon: "pi pi-align-left" },
              ],
            },
            {
              label: "Submenu 2.2",
              icon: "pi pi-align-left",
              items: [
                { label: "Submenu 2.2.1", icon: "pi pi-align-left" },
                { label: "Submenu 2.2.2", icon: "pi pi-align-left" },
              ],
            },
          ],
        },
      ],
    },
    {
      label: "Start",
      icon: "pi pi-download",
      items: [
        {
          label: "Documentation",
          icon: "pi pi-question",
          to: "/documentation",
        },
        {
          label: "Buy Now",
          icon: "pi pi-shopping-cart",
          command: () => {
            window.location.pathname = "https://www.primefaces.org/store";
          },
        },
      ],
    },
  ]

  const callCenterItems = [
    { label: "Pedir Corrida", icon: "pi pi-car", to: "/pedir-corrida" },
    { label: "Monitor", icon: "pi pi-bell", to: "/monitor" },
  ];

  if (is_callcenter) callCenterItems.push({ label: "Minhas Corridas", icon: "pi pi-car", to: "/minhas-corridas" })

  const callCenterMenu = [
    {
      label: "Central de Chamadas",
      icon: "pi pi-desktop",
      items: callCenterItems,
    },
  ];

  const panelMenu = [
    // {
    //   label: "Favorites",
    //   icon: "pi pi-home",
    //   items: [{ label: "Dashboard", icon: "pi pi-home", to: "/" }],
    // },
    {
      label: "Motoristas",
      icon: "pi pi-id-card",
      to: "/motoristas",
      // items: [{ label: "Usuarios", icon: "pi pi-user", to: "/usuarios" }],
    },
    {
      label: "Passageiros",
      icon: "pi pi-id-card",
      to: "/clientes",
      // items: [{ label: "Usuarios", icon: "pi pi-user", to: "/usuarios" }],
    },
    {
      label: "Gestão",
      icon: "pi pi-sitemap",
      items: gestaoList(),
    },
    {
      label: "Cadastros",
      icon: "pi pi-cog",
      items: cadastroList(),
    },
    {
      label: "Relatórios",
      icon: "pi pi-list",
      items: [
        { label: "Corridas", icon: "pi pi-car", to: "/relatorio-corridas" },
        { label: "Métricas", icon: "pi pi-chart-pie", to: "/relatorio-metricas" },
      ],
    },
    {
      label: "Mensagens",
      icon: "pi pi-envelope",
      to: "/mensagens",
    },
    ...callCenterMenu,
    {
      label: "Monitoramento",
      icon: "pi pi-desktop",
      to: "/monitoring",
    },
  ];

  const menu: any[] = is_callcenter ? [...callCenterMenu] : [...panelMenu];

  // menu.push(...devMenu); // Hong Li

  const routes = [
    { parent: "Gestão", label: "Usuários", path: "/usuarios" },
    { parent: "Gestão", label: "Parâmetros", path: "/parametros" },
    { parent: "Gestão", label: "Planos", path: "/planos" },
    { parent: "Gestão", label: "Mensagens", path: "/mensagens" },
    { parent: "Gestão", label: "Monitoramento", path: "/monitoring" },
    { parent: "Central de Chamadas", label: "Pedir Corrida", path: "/pedir-corrida" },
    { parent: "Central de Chamadas", label: "Monitor", path: "/monitor" },
    { parent: "Central de Chamadas", label: "Minhas Corridas", path: "/minhas-corridas"},
    { parent: "Cadastro", label: "Franquias", path: "/franquias"},
    { parent: "Cadastro", label: "Cupons", path: "/cupons"},
    { parent: "Cadastro", label: "Franquia - Região de atuação", path: "/franquias-regioes"},
    { parent: "Cadastro", label: "Serviços", path: "/servicos" },
    { parent: "Cadastro", label: "Categorias", path: "/categorias" },
    { parent: "Cadastro", label: "Regiões de atuação", path: "/regioes" },
    { parent: "Relatório", label: "Clientes", path: "/clientes"},
    { parent: "Cadastro", label: "Motoristas", path: "/motoristas" },
    { parent: "Cadastro", label: "Modelos de veículos", path: "/modelos-de-veiculos" },
    { parent: "Cadastro", label: "Marcas de veículos", path: "/marcas-de-veiculos" },
    { parent: "Cadastro", label: "Motivos & Assuntos", path: "/motivos" },
    { parent: "Relatório", label: "Corridas", path: "/relatorio-corridas"},
    { parent: "Relatório", label: "Métricas", path: "/relatorio-metricas"},
    // { parent: "Dashboard", label: "Sales Dashboard" },
    // { parent: "UI Kit", label: "Form Layout" },
    // { parent: "UI Kit", label: "Input" },
    // { parent: "UI Kit", label: "Float Label" },
    // { parent: "UI Kit", label: "Invalid State" },
    // { parent: "UI Kit", label: "Button" },
    // { parent: "UI Kit", label: "Table" },
    // { parent: "UI Kit", label: "List" },
    // { parent: "UI Kit", label: "Panel" },
    // { parent: "UI Kit", label: "Tree" },
    // { parent: "UI Kit", label: "Overlay" },
    // { parent: "UI Kit", label: "Menu" },
    // { parent: "UI Kit", label: "Media" },
    // { parent: "UI Kit", label: "Message" },
    // { parent: "UI Kit", label: "File" },
    // { parent: "UI Kit", label: "Chart" },
    // { parent: "UI Kit", label: "Misc" },
    // { parent: "UI Blocks", label: "Blocks" },
    // { parent: "Utilities", label: "Icons" },
    // { parent: "Pages", label: "Crud" },
    // { parent: "Pages", label: "Calendar" },
    // { parent: "Pages", label: "Timeline" },
    // { parent: "Pages", label: "Invoice" },
    // { parent: "Pages", label: "Login" },
    // { parent: "Pages", label: "Help" },
    // { parent: "Pages", label: "Empty" },
    // { parent: "Pages", label: "Access" },
    // { parent: "Start", label: "Documentation" },
  ];

  let rightMenuClick: any;
  let configClick: any;
  let menuClick: any;
  let searchClick: boolean = false;
  let topbarItemClick: any;

  useEffect(() => {
    copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
  }, [location]);

  useEffect(() => {
    setResetActiveIndex(true);
    setMenuActive(false);
  }, [menuMode]);

  const onDocumentClick = () => {
    if (!searchClick && searchActive) {
      onSearchHide();
    }

    if (!topbarItemClick) {
      setTopbarMenuActive(false);
    }

    if (!menuClick) {
      if (isHorizontal() || isSlim()) {
        setMenuActive(false);
        setResetActiveIndex(true);
      }

      if (overlayMenuActive || staticMenuMobileActive) {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
      }

      hideOverlayMenu();
      unblockBodyScroll();
    }

    if (!rightMenuClick) {
      setRightMenuActive(false);
    }

    if (configActive && !configClick) {
      setConfigActive(false);
    }

    topbarItemClick = false;
    menuClick = false;
    configClick = false;
    rightMenuClick = false;
    searchClick = false;
  };

  const onSearchHide = () => {
    setSearchActive(false);
    searchClick = false;
  };

  const onMenuModeChange = (menuMode: any) => {
    setMenuMode(menuMode);
    setOverlayMenuActive(false);
  };

  const onRightMenuButtonClick = () => {
    rightMenuClick = true;
    setRightMenuActive(true);
  };

  const onRightMenuClick = () => {
    rightMenuClick = true;
  };

  const onRightMenuActiveChange = (active: any) => {
    setRightMenuActive(active);
  };

  const onConfigClick = () => {
    configClick = true;
  };

  const onConfigButtonClick = (event: any) => {
    setConfigActive(prevState => !prevState);
    configClick = true;
    event.preventDefault();
  };

  const onRippleChange = (e: any) => {
    PrimeReact.ripple = e.value;
    setRipple(e.value);
  };

  const onMenuButtonClick = (event: any) => {
    menuClick = true;

    if (isOverlay()) {
      setOverlayMenuActive(prevState => !prevState);
    }

    if (isDesktop()) {
      setStaticMenuDesktopInactive(prevState => !prevState);
    } else {
      setStaticMenuMobileActive(prevState => !prevState);
    }

    event.preventDefault();
  };

  const hideOverlayMenu = () => {
    setOverlayMenuActive(false);
    setStaticMenuMobileActive(false);
  };

  const onTopbarItemClick = (event: any) => {
    topbarItemClick = true;
    setTopbarMenuActive(prevState => !prevState);
    hideOverlayMenu();
    event.preventDefault();
  };

  const onToggleMenu = (event: any) => {
    menuClick = true;

    if (overlayMenuActive) {
      setOverlayMenuActive(false);
    }

    if (sidebarActive) {
      setSidebarStatic(prevState => !prevState);
    }

    event.preventDefault();
  };

  const onSidebarMouseOver = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setSidebarActive(isDesktop());
      setTimeout(() => {
        setPinActive(isDesktop());
      }, 200);
    }
  };

  const onSidebarMouseLeave = () => {
    if (menuMode === "sidebar" && !sidebarStatic) {
      setTimeout(() => {
        setSidebarActive(false);
        setPinActive(false);
      }, 250);
    }
  };

  const onMenuClick = () => {
    menuClick = true;
  };

  const onChangeActiveInlineMenu = (event: any) => {
    setActiveInlineProfile(prevState => !prevState);
    event.preventDefault();
  };

  const onRootMenuItemClick = () => {
    setMenuActive(prevState => !prevState);
  };

  const onMenuItemClick = (event: any) => {
    if (!event.item.items) {
      hideOverlayMenu();
      setResetActiveIndex(true);
    }

    if (!event.item.items && (isHorizontal() || isSlim())) {
      setMenuActive(false);
    }
  };

  const isHorizontal = () => {
    return menuMode === "horizontal";
  };

  const isSlim = () => {
    return menuMode === "slim";
  };

  const isOverlay = () => {
    return menuMode === "overlay";
  };

  const isDesktop = () => {
    return window.innerWidth > 991;
  };

  const onInputClick = () => {
    searchClick = true;
  };

  const breadcrumbClick = () => {
    searchClick = true;
    setSearchActive(true);
  };

  const unblockBodyScroll = () => {
    if (document.body.classList) {
      document.body.classList.remove("blocked-scroll");
    } else {
      document.body.className = document.body.className.replace(new RegExp("(^|\\b)" + "blocked-scroll".split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
  };

  const layoutClassName = classNames("layout-wrapper", {
    "layout-static": menuMode === "static",
    "layout-overlay": menuMode === "overlay",
    "layout-overlay-active": overlayMenuActive,
    "layout-slim": menuMode === "slim",
    "layout-horizontal": menuMode === "horizontal",
    "layout-active": menuActive,
    "layout-mobile-active": staticMenuMobileActive,
    "layout-sidebar": menuMode === "sidebar",
    "layout-sidebar-static": menuMode === "sidebar" && sidebarStatic,
    "layout-static-inactive": staticMenuDesktopInactive && menuMode === "static",
    "p-ripple-disabled": !ripple,
  });

  return (
    <>
    <div className={layoutClassName} onClick={onDocumentClick}>
      <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

      <div className="layout-main">
        <AppTopbar
          items={menu}
          menuMode={menuMode}
          colorScheme={props.colorScheme}
          menuActive={menuActive}
          topbarMenuActive={topbarMenuActive}
          activeInlineProfile={activeInlineProfile}
          onTopbarItemClick={onTopbarItemClick}
          onMenuButtonClick={onMenuButtonClick}
          onSidebarMouseOver={onSidebarMouseOver}
          onSidebarMouseLeave={onSidebarMouseLeave}
          onToggleMenu={onToggleMenu}
          onChangeActiveInlineMenu={onChangeActiveInlineMenu}
          onMenuClick={onMenuClick}
          onMenuItemClick={onMenuItemClick}
          onRootMenuItemClick={onRootMenuItemClick}
          resetActiveIndex={resetActiveIndex}
        />

        <AppMenu
          model={menu}
          onRootMenuItemClick={onRootMenuItemClick}
          onMenuItemClick={onMenuItemClick}
          onToggleMenu={onToggleMenu}
          onMenuClick={onMenuClick}
          menuMode={menuMode}
          colorScheme={props.colorScheme}
          menuActive={menuActive}
          sidebarActive={sidebarActive}
          sidebarStatic={sidebarStatic}
          pinActive={pinActive}
          onSidebarMouseLeave={onSidebarMouseLeave}
          onSidebarMouseOver={onSidebarMouseOver}
          activeInlineProfile={activeInlineProfile}
          onChangeActiveInlineMenu={onChangeActiveInlineMenu}
          resetActiveIndex={resetActiveIndex}
        />

        <AppBreadcrumb
          routes={routes}
          onMenuButtonClick={onMenuButtonClick}
          menuMode={menuMode}
          onRightMenuButtonClick={onRightMenuButtonClick}
          onInputClick={onInputClick}
          searchActive={searchActive}
          breadcrumbClick={breadcrumbClick}
        />

        <div className="layout-main-content">
          <Routes>
            <Route path="/" element={is_callcenter ? (<OrdersCrud />) : (<ReportMetricsCrud />)} />
            <Route path="/usuarios" element={<UsersCrud />} />
            <Route path= "/franquias" element={<FranchisesCrud />} />
            <Route path= "/cupons" element={<CouponsCrud />} />
            <Route path= "/franquias-regioes" element={<FranchiseRegionsCrud />} />
            <Route path="/servicos" element={<ServicesCrud />} />
            <Route path="/categorias" element={<CategorysCrud />} />
            <Route path="/regioes" element={<RegionsCrud />} />
            <Route path="/parametros" element={<ParameterCrud />} />
            <Route path="/marcas-de-veiculos" element={<VehicheBrandCrud />} />
            <Route path="/modelos-de-veiculos" element={<VehicheModelCrud />} />
            <Route path="/motivos" element={<ReasonCrud />} />
            <Route path="/planos" element={<PlansCrud />} />
            <Route path="/relatorio-corridas" element={<ReportRacesCrud />} />
            <Route path="/minhas-corridas" element={<ReportRacesCrud />} />
            <Route path="/relatorio-metricas" element={<ReportMetricsCrud />} />

            <Route path="/clientes" element={<ReportClientsCrud />} />
            <Route path="/motoristas" element={<DriversCrud />} />
            <Route path="/mensagens" element={<MessagesCrud />} />
            <Route path="/monitoring" element={<MonitoringCrud />} />
            <Route path="/pedir-corrida" element={<OrdersCrud />} />
            <Route path="/monitor" element={<MonitorCrud />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/formlayout" element={<FormLayoutDemo />} />
            <Route path="/floatlabel" element={<FloatLabelDemo />} />
            <Route path="/input" element={<InputDemo />} />
            <Route path="/invalidstate" element={<InvalidStateDemo />} />
            <Route path="/button" element={<ButtonDemo />} />
            <Route path="/table" element={<TableDemo />} />
            <Route path="/list" element={<ListDemo />} />
            <Route path="/tree" element={<TreeDemo />} />
            <Route path="/panel" element={<PanelDemo />} />
            <Route path="/overlay" element={<OverlayDemo />} />
            <Route path="/menu/*" element={<MenuDemo />} />
            <Route path="/message" element={<MessagesDemo />} />
            <Route path="/media" element={<MediaDemo />} />
            <Route path="/file" element={<FileDemo />} />
            <Route path="/chart" element={<ChartDemo colorMode={props.colorScheme} location={location} />} />
            <Route path="/misc" element={<MiscDemo />} />
            <Route path="/blocks" element={<BlocksDemo />} />
            <Route path="/icons" element={<IconsDemo />} />
            <Route path="/crud" element={<CrudDemo />} />
            <Route path="/calendar" element={<CalendarDemo />} />
            <Route path="/help" element={<Help />} />
            <Route path="/invoice" element={<Invoice colorMode={props.colorScheme} location={location} />} />
            <Route path="/empty" element={<EmptyPage />} />
            <Route path="/timeline" element={<TimelineDemo />} />
          </Routes>
        </div>

        <AppFooter colorScheme={props.colorScheme} />
      </div>

      {/* <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} /> */}

      {/* <AppConfig
        configActive={configActive}
        onConfigButtonClick={onConfigButtonClick}
        onConfigClick={onConfigClick}
        menuMode={menuMode}
        changeMenuMode={onMenuModeChange}
        colorScheme={props.colorScheme}
        changeColorScheme={props.onColorSchemeChange}
        theme={props.theme}
        changeTheme={props.onMenuThemeChange}
        componentTheme={props.componentTheme}
        changeComponentTheme={props.onComponentThemeChange}
        ripple={ripple}
        onRippleChange={onRippleChange}
      /> */}
    </div>
    </>
  );
};

export default App;
